import { useCallback, useEffect, useState } from "react";

import { useConfigContext } from "../../contexts/ConfigContext/ConfigContext";

const CHECK_INTERVAL_MS = 30000;

const isOrderExpired = (_orderUntil: string | null | undefined): boolean => {
	return false;
};

const useOrderTimeRestriction = () => {
	const { state: qrSession } = useConfigContext((state) => state.qrSession);
	const [isExpired, setIsExpired] = useState(() => isOrderExpired(qrSession?.order_until));

	useEffect(() => {
		if (!qrSession?.order_until) return;

		const orderUntil = qrSession.order_until;
		const interval = setInterval(() => setIsExpired(isOrderExpired(orderUntil)), CHECK_INTERVAL_MS);

		return () => clearInterval(interval);
	}, [qrSession?.order_until]);

	const checkExpiry = useCallback((): boolean => {
		setIsExpired(false);

		return false;
	}, []);

	return { isExpired, checkExpiry };
};

export default useOrderTimeRestriction;
